module.exports = __webpack_public_path__ + "img/No-data.61e9e95b.svg";